(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game-app/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/components/numbergames/game-app/assets/javascripts/prescript.js');

'use strict';

svs.numbergames = svs.numbergames || {};
svs.numbergames.game_app = svs.numbergames.game_app || {};
svs.numbergames.game_app.behaviors = svs.numbergames.game_app.behaviors || {};
svs.numbergames.game_app.utils = svs.numbergames.game_app.utils || {};

 })(window);